import { breakpoints } from './helpers/constants';

export const updateHomepageDynamicStyles = () => {
  const homePageLeftBorder = document.querySelector(
    '.homepage-masthead__left-border'
  );
  const homeMastheadMediaContainer = document.querySelector(
    '.homepage-masthead__media-container'
  );
  const headerExpandedShortcuts = document.querySelector(
    '.header__expanded-shortcuts'
  );
  if (window.innerWidth < breakpoints.tabletLandscape) {
    if (homeMastheadMediaContainer && homePageLeftBorder) {
      const svgHeight = document.querySelector(
        '.homepage-masthead__header-logo'
      ).offsetHeight;
      const borderTopPosition =
        homeMastheadMediaContainer.offsetTop - svgHeight / 2;
      // Update left border top value
      homePageLeftBorder.style.top = `${borderTopPosition}px`;
      homePageLeftBorder.style.height = 'auto';
    }
  } else {
    // Update header expanded shortcuts nav height
    if (homeMastheadMediaContainer && headerExpandedShortcuts) {
      const {
        top: mastheadMediaTop
      } = homeMastheadMediaContainer.getBoundingClientRect();
      const offset = window.innerWidth > breakpoints.desktop ? 140 : 100;
      headerExpandedShortcuts.style.height = `${mastheadMediaTop - offset}px`;
    }
  }
};

export const calculateLeftBorderHeight = (leftBorderElement, update = true) => {
  const updateTop = () => {
    const headerOffset = document.querySelector('header').offsetTop;
    const offset = window.innerWidth < breakpoints.laptop ? 32 : 44;
    const top = headerOffset + offset;
    leftBorderElement.style.top = `${top}px`;
    return top;
  };

  const defaultResolver = (element, update) => {
    const top = element.offsetTop;
    const leftBorderTop = updateTop();
    if (update) leftBorderElement.style.height = `${top - leftBorderTop}px`;
    return top;
  };

  const footerResolver = (element, update) => {
    const top = element.offsetTop;
    const height = element.offsetHeight;
    const leftBorderTop = updateTop();
    if (window.innerWidth < breakpoints.desktop) {
      if (update) leftBorderElement.style.height = `${top - leftBorderTop}px`;
    } else {
      if (update)
        leftBorderElement.style.height = `${
          top + Math.floor(height / 2) - 50 - leftBorderTop
        }px`;
    }
  };

  const visualStoryRowResolver = (element, update) => {
    const top = element.offsetTop;
    const offset = element.querySelector('.visual-story-row__image').offsetTop;
    const leftBorderTop = updateTop();
    const leftBorderHeight = top + offset - leftBorderTop;
    if (update) leftBorderElement.style.height = `${leftBorderHeight}px`;
    return leftBorderHeight;
  };

  const exploreAllFourResolver = (element, update) => {
    const leaf = element.querySelector('.explore-all-four__leaf');
    const top = element.offsetTop;
    const height = leaf.offsetHeight;
    const leftBorderTop = updateTop();
    const leftBorderHeight = top + Math.floor(height / 2) - leftBorderTop;
    if (update) leftBorderElement.style.height = `${leftBorderHeight}px`;
    return leftBorderHeight;
  };

  const fullScreenModules = [
    {
      selector: '.timeline',
      selectorType: 'class',
      elementClass: 'timeline',
      resolver: defaultResolver
    },
    {
      selector: '.values',
      selectorType: 'class',
      elementClass: 'values',
      resolver: defaultResolver
    },
    {
      selector: '.quick-statistics',
      selectorType: 'class',
      elementClass: 'quick-statistics',
      resolver: defaultResolver
    },
    {
      selector: '.flexible-carousel--dark',
      selectorType: 'class',
      elementClass: 'flexible-carousel--dark',
      resolver: defaultResolver
    },
    {
      selector: '.featured-content-row',
      selectorType: 'class',
      elementClass: 'featured-content-row',
      resolver: defaultResolver
    },
    {
      selector: '.featured-vertical-cards:not(.featured-vertical-cards--light)',
      selectorType: 'class',
      elementClass: 'featured-vertical-cards',
      resolver: defaultResolver
    },
    {
      selector: '.who-we-are:not(.who-we-are--light)',
      selectorType: 'class',
      elementClass: 'who-we-are',
      resolver: defaultResolver
    },
    {
      selector: '.footer',
      selectorType: 'class',
      elementClass: 'footer',
      resolver: footerResolver
    },
    {
      selector: '[data-module="filterContentModule"]',
      selectorType: 'dataModule',
      elementDataModule: 'filterContentModule',
      resolver: defaultResolver
    },
    {
      selector: '.visual-story-row',
      selectorType: 'class',
      elementClass: 'visual-story-row',
      resolver: visualStoryRowResolver
    },
    {
      selector: '.explore-all-four',
      selectorType: 'class',
      elementClass: 'explore-all-four',
      resolver: exploreAllFourResolver
    },
    {
      selector: '.up-cards.up-cards--dark',
      selectorType: 'class',
      elementClass: 'up-cards',
      resolver: defaultResolver
    },
    {
      selector: '.event-finder',
      selectorType: 'class',
      elementClass: 'event-finder',
      resolver: defaultResolver
    }
  ];

  const getFullScreenModulesSelector = () =>
    fullScreenModules.map(module => module.selector).join(', ');
  // Get first full screen element
  const fullScreenElement = document.querySelector(
    getFullScreenModulesSelector()
  );

  // Return if there are no full screen elements
  if (!fullScreenElement) return;
  // Get the full screen module that would be the stopper of the left border
  const stopper = fullScreenModules.find(module => {
    if (module.selectorType === 'class') {
      return fullScreenElement.classList.contains(module.elementClass);
    } else if (module.selectorType === 'dataModule') {
      return fullScreenElement.dataset.module === module.elementDataModule;
    }
  });
  // Check resolver type
  if (window.innerWidth >= breakpoints.tabletLandscape) {
    return stopper.resolver(fullScreenElement, update);
  }
};

export class ScrollManager {
  constructor() {
    this.scrollTop = 0;
    this.scrollLeft = 0;
  }

  disableScroll() {
    const scrolledPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrolledPosition}px`;
    this.scrollTop = scrolledPosition;
    this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  }

  enableScroll() {
    document.body.style.position = '';
    window.scrollTo(this.scrollLeft, this.scrollTop);
  }
}
